module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "section"
    }
  }, [_c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), (_vm.plist.length > 0) ? _c('div', {
    staticClass: "el-table demo-table el-table--fit el-table--striped el-table--border el-table--group el-table--enable-row-hover el-table--enable-row-transition",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "ta"
    }
  }, [_c('div', {
    staticClass: "el-table__header-wrapper"
  }, [_c('table', {
    staticClass: "el-table__header",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0",
      "id": "ta"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('tbody', {
    staticClass: "el-table__body"
  }, [_vm._l((_vm.plist), function(item, index) {
    return _c('tr', {
      staticClass: "el-table__row",
      class: index % 2 == 1 ? 'el-table__row--striped' : ''
    }, [_c('td', {
      staticClass: "el-table_3_column_28_column_29 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell",
      on: {
        "click": function($event) {}
      }
    }, [_c('span', [_vm._v(_vm._s(item.bill_sdate) + "~" + _vm._s(item.bill_edate))])])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_30 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.product_name))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_31 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.channel_name))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_32 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.platform))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_33 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.ctype))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_34 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.num))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_35 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.atv))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_36 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.amount))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_36 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.type_text))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_36 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell blue",
      on: {
        "click": function($event) {
          return _vm.$router.push({
            name: '成本日报详情',
            params: {
              issued_app_id: item.issued_app_id
            },
            query: {
              sdate: item.bill_sdate,
              edate: item.bill_edate,
              channel_id: item.channel_id
            }
          })
        }
      }
    }, [_vm._v("查看详情")])])])
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("结算类型\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.company.type == 1 ? '企业' : '个人') + "\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("发票类型\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.bill.invoice_type == 1 ? '普通发票' : '增值发票') + "\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("新增用户\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.bill.num) + "\t")])]), _vm._v(" "), (_vm.bill.offset == 1) ? _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("抵扣金额\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.bill.offset_amount) + "\t")])]) : _vm._e(), _vm._v(" "), _c('tr', [(_vm.company.type == 1) ? _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("结算金额\t")]) : _vm._e(), _vm._v(" "), (_vm.company.type == 2) ? _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("结算金额(扣去税点后金额)\t")]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.bill.bill_amount) + "\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("结算金额（人民币大写）\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.bill.big_bill_amount) + "\t")])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("乙方公司 ：" + _vm._s(_vm.company.name))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("税号：" + _vm._s(_vm.company.social_credit_code))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[3]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("注册地址：" + _vm._s(_vm.company.company_addr))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[4]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("注册电话：" + _vm._s(_vm.company.company_phone))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[8]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("开户银行 ：" + _vm._s(_vm.company.opening_bank))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("银行 账号：" + _vm._s(_vm.company.receiving_account))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[2]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("联系人：" + _vm._s(_vm.company.contact))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[6]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("联系电话：" + _vm._s(_vm.company.phone))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[7]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("邮寄地址：" + _vm._s(_vm.company.email_addr))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[5]))])])], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.plist.length == 0) ? _c('div', [_vm._v("\n\t\t\t暂无对账单\n\t\t")]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新日志",
      "visible": _vm.logDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_29",
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_30",
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_31",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_32",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_33",
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_34",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_35",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_36",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_36",
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_36",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "gutter",
      "width": "0"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "is-group has-gutter"
  }, [_c('tr', {}, [_c('th', {
    staticClass: "el-table_3_column_28  is-center  ",
    attrs: {
      "colspan": "10",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算对账单")])])]), _vm._v(" "), _c('tr', {}, [_c('th', {
    staticClass: "el-table_3_column_28_column_29  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算周期")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_30  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("游戏名称")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_31  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("渠道名称")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_32  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("平台")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_33  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("合作方式")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_34  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("计价人数")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_35  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("单价（元/个）")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_36  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("应付金额（￥）")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_36  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("类型")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_36  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("操作")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "10"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "10"
    }
  }, [_vm._v(" ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7146db98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/income/dataDetail.vue
// module id = 1143
// module chunks = 2